import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS, FONTS } from '../../../constants'

export const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    overflow: 'hidden',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      width: '90%',
    },
  },
  wrapper: {},
  itemsWrapper: {
    ['@media screen and (max-width: 768px)']: {
      marginTop: '3rem',
    },
    ['@media screen and (max-width: 600px)']: {
      marginTop: '1rem',
    },
  },
  perItems: {
    display: 'none',
    fontFamily: FONTS.Graphik.GraphikRegular + ' !important',
    textTransform: 'uppercase',
    letterSpacing: 1,
    fontSize: '1rem',
    lineHeight: '1.125',
    marginBottom: '42px !important',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      display: 'block',
    },
  },
  summaryItems: {},
  container404: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 960,
    margin: '0px auto',
  },
  logo: {
    display: 'block',
    marginBottom: 40,
  },
  button404: {
    maxWidth: 460,
  },
  iconBtn: {
    background: 'transparent',
    width: '44px !important',
    minWidth: '44px !important',
    minHeight: '44px !important',
    height: '44px !important',
    color: theme.palette.common.black,
    transition: '0.5s',
    margin: 0,
    ['&:focus']: {
      outline: 'none',
    },
    ['&:focus-visible']: {
      outline: `2px solid ${theme.palette.common.black}`,
      outlineOffset: 2,
    },
    ['& > p']: {
      color: theme.palette.common.black,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      lineHeight: 1,
    },
    ['&:hover']: {
      color: theme.palette.common.white,
      background: theme.palette.common.black,
      borderColor: theme.palette.common.black,
      ['& > p']: {
        color: theme.palette.common.white,
      },
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      width: '60px !important',
      minWidth: '60px !important',
      minHeight: '54px !important',
      height: '54px !important',
    },
  },
  iconBtnLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 0,
  },
  iconBtnWrap: {
    display: 'inline-flex',
    flexShrink: 0,
  },
  iconActions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
    width: '100%',
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      width: 'auto',
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      gap: 12,
    },
  },
  btn: {
    background: 'none',
    minWidth: 0,
    minHeight: 44,
    width: '100%',
    maxWidth: '100%',
    color: theme.palette.common.black,
    transition: '0.5s',
    margin: 0,
    ['&:focus']: {
      outline: 'none',
    },
    ['& > p']: {
      color: theme.palette.common.black,
      fontSize: '0.8125rem',
      lineHeight: 1.2,
      textAlign: 'center',
      padding: '0 12px',
    },
    ['&:hover']: {
      color: theme.palette.common.white,
      background: theme.palette.common.black,
      borderColor: theme.palette.common.black,
      ['& > p']: {
        color: theme.palette.common.white,
      },
    },
    ['& > img']: {
      width: '14px',
      height: 'auto',
      left: '19px',
    },
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      minWidth: 180,
      maxWidth: 240,
      width: 'auto',
      ['& > p']: {
        fontSize: '0.875rem',
        padding: '0 20px',
      },
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      minWidth: 210,
      maxWidth: 263,
      minHeight: 54,
      ['& > p']: {
        padding: '0 24px',
      },
    },
  },

  subGrid: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    paddingLeft: 16,
    paddingRight: 16,
    marginTop: 24,
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      paddingLeft: 20,
      paddingRight: 20,
      marginTop: 28,
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      paddingLeft: 0,
      paddingRight: 0,
      marginTop: 0,
    },
  },
  titleActionsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 16,
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 24,
    },
  },
  titleBlock: {
    flex: '1 1 auto',
    minWidth: 0,
    maxWidth: '100%',
    width: '100%',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      width: 'auto',
      paddingRight: 16,
    },
  },
  subGridContainer: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    marginBottom: 10,
    ['& hr']: {
      backgroundColor: 'whitesmoke',
    },
  },
  backBtn: {
    color: 'dimgray',
    paddingLeft: 0,
    minHeight: 44,
  },
  // Trails the folder name in the header; admins only, so it never shifts a visitor's layout.
  folderNameBadge: {
    marginLeft: 8,
    verticalAlign: 'middle',
  },
  folderName: {
    fontSize: '1.75rem',
    lineHeight: 1.2,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    maxWidth: '100%',
    margin: '12px 0 8px',
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      fontSize: '2.25rem',
      lineHeight: 1.15,
      margin: '16px 0 12px',
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      fontSize: '2.8125rem',
      lineHeight: 1.15,
      margin: 0,
    },
  },
  userLink: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '5px',
    flexWrap: 'wrap',
    minWidth: 0,
    ['& a']: {
      textDecorationColor: 'black',
      color: 'black',
    },
  },
  userInfoSection: {
    marginTop: 15,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 8,
    width: '100%',
  },
  profileImgContainer: {
    marginLeft: 2,
    width: 20,
    height: 20,
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
  },
  profileImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  userProfileLink: {
    color: COLORS.black,
    textDecorationColor: COLORS.black,
  },

  privateWrapper: {
    maxWidth: 668,
    width: '100%',
    margin: '120px auto 0',
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      marginTop: 60,
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  shoppingLink: {
    color: '#000',
  },
  inputNameWrapper: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    marginBottom: 8,
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      marginBottom: 0,
      flexWrap: 'nowrap',
    },
  },
  nameInput: {
    width: '100%',
    display: 'inline',
    padding: '5px 0',
    fontSize: '1.75rem',
    lineHeight: '1.2',
    fontFamily: FONTS.Schnyder.SchnyderMLight,
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0,
    zIndex: -1,
    letterSpacing: 0,
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      fontSize: '2.25rem',
      lineHeight: '1.15',
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      fontSize: '3.75rem',
      lineHeight: '1.17',
      margin: '0 0 10px',
      textTransform: 'lowercase',
      top: -5,
      left: 2,
    },
  },
  nameInputShow: {
    zIndex: 0,
    opacity: 10,
    backgroundColor: '#FFF',
    border: 'none',
  },
  nameLabel: {
    fontSize: '0.875rem',
    color: '#CDCDCD',
    padding: '6px 0',
    boxShadow: 'inset 0 -2px white, inset 0 -3px #CDCDCD',
    border: 0,
    background: 'none',
    outline: 'none',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      position: 'relative',
      top: '-10px',
    },
  },
  nameText: {
    fontSize: '1.75rem',
    lineHeight: 1.2,
    fontFamily: FONTS.Schnyder.SchnyderMLight,
    display: 'block',
    padding: '0 2px',
    minWidth: 0,
    maxWidth: '100%',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      fontSize: '2.25rem',
      lineHeight: 1.15,
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      fontSize: '3.75rem',
      lineHeight: 1.17,
      minHeight: 52,
      textTransform: 'lowercase',
      display: 'inline',
    },
  },
  nameTexthHide: {
    opacity: 0,
    position: 'relative',
    zIndex: -4,
  },
  btnEdit: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: 44,
    height: 44,
    minWidth: 44,
    minHeight: 44,
    borderRadius: '50%',
    background: COLORS.white,
    padding: 4,
    textAlign: 'center',
    fontSize: '1rem',
    border: 0,
    marginLeft: 0,
    marginTop: 0,
    outline: 'none',
    flexShrink: 0,
    ['&:focus-visible']: {
      outline: `2px solid ${COLORS.black}`,
      outlineOffset: 2,
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      width: 52,
      height: 52,
      minWidth: 52,
      minHeight: 52,
      padding: 15,
      marginLeft: 5,
      marginTop: 5,
      ['& img']: {
        width: '22px',
      },
    },
  },
  btnEditHide: {
    opacity: 0,
    position: 'relative',
    zIndex: -4,
  },
  btnIcon: {
    width: 16,
  },
  nameValidation: {
    position: 'relative',
    color: COLORS.dangerRed,
    paddingTop: 8,
    display: 'block',
  },
  subBtns: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: 10,
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 12,
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      justifyContent: 'flex-end',
      width: 'auto',
      flex: '0 1 auto',
      maxWidth: '55%',
      gap: 15,
    },
  },
  btnOther: {
    ['& > p']: {
      padding: '0 12px',
      width: '100%',
      justifyContent: 'center',
    },
    ['&:hover']: {
      ['& > img']: {
        filter: 'invert(100%)',
      },
    },
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      ['& > p']: {
        padding: '0 20px',
      },
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      ['& > p']: {
        padding: '0 40px',
      },
    },
  },
  createEditPageBtnWrap: {
    display: 'block',
    width: '100%',
    minWidth: 0,
    [`@media (min-width: ${BREAKPOINTS.sm}px)`]: {
      display: 'inline-flex',
      width: 'auto',
      flex: '1 1 auto',
      maxWidth: '100%',
    },
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      flex: '0 1 auto',
    },
  },
  forwardedFolderLink: {
    position: 'relative',
    maxWidth: 400,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    boxSizing: 'border-box',
    paddingLeft: 16,
    paddingRight: 16,
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
    ['& > input']: {
      color: theme.palette.common.black,
      letterSpacing: 1.2,
      textAlign: 'center',
      background: 'white',
      border: `1px solid ${COLORS.lightGrey}`,
      width: '100%',
      boxSizing: 'border-box',
    },
    ['& > button']: {
      position: 'absolute',
      right: 16,
      top: 0,
      width: '100px',
      margin: 0,
      [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
        right: 0,
      },
    },
  },
}))
